export namespace AlarmsEdasTypes {
  export interface EdasAlarms {
    id: number;
    uid: string;
    alarms: EdasAlarm[];
  }

  export interface EdasAlarm {
    type_alarm: string;
    type_trigger: string;
    type_alert: string;
    type_option: number;
    relay: string;
    win_val: number;
    hysteresis: number;
    pre_val: number;
    post_val: number;
    threshold: number;
    identifier: string;
    location_id: number;
    location_name: string;
    location_length: number;
    sensor_uid: string;
    dau_uid: string;
    spcu_uid: string;
  }
  export const edasAlarmDisplayedColumns = [
    "type_alarm",
    "identifier",
    "type_trigger",
    "type_alert",
     "relay",
    "win_val",
    "hysteresis",
    "pre_val",
    "post_val",
    "threshold",
    "type_option",
    "location_id",
    "location_name",
    "dau_uid",
    "sensor_uid",
  ];
  export enum EdasRelay {
    None = "NONE",
    R1 = "R1",
    R2 = "R2",
  }

  export enum EdasTypeAlarm {
    Dyn = "DYN",
    Sta = "STA",
  }

  export enum EdasTypeAlert {
    High = "HIGH",
    Min = "MIN",
    Normal = "NORMAL",
  }

  export enum EdasTypeTrigger {
    Amplitude = "AMPLITUDE",
    Max = "MAX",
    Min = "MIN",
  }
}
